"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTC_CONNECT_USER_VALIDATION_TOKE_KEY_NAME = "Token";
exports.RTC_CONNECT_ID = "userid";
exports.RTC_CONNECT_NAME = "username";
exports.RTC_BINDING_USER_KEY_NAME = "user";
exports.RTC_BINDING_LANGYAN_USER_KEY_NAME = "LangyanUser";
exports.RTC_CHATTING_CHAT_CHANNEL_NAME = "/users/chat";
exports.RTC_CHATTING_ONLINE_CHANNEL_NAME = "/users/online";
exports.RTC_CHATTING_OFFLINE_CHANNEL_NAME = "/users/offline";
exports.RTC_CHATTING_COMMAND_CHANNEL_NAME = "/users/command";
exports.RTC_CHATTING_EVENT_CHANNEL_NAME = "/users/event";
exports.RTC_COMMAND_SERVICE_CHANNEL_NAME = "/langyan/command";
//# sourceMappingURL=ProtocolConstant.js.map